import React from 'react'
import LazyLoad from 'react-lazyload'
import { DesignRow } from 'components/design'
import { Rimg } from 'components/images'

export default function HorizontalImage({ className, descriptor, image, wrapper }) {
	const Image = () => (
		<LazyLoad once height={700} offset={400}>
			<Rimg image={image} position="horizontalImage" alt={image?.alt || ''} />
		</LazyLoad>
	)

	return (
		<DesignRow
			className={`${className || 'my-16'}`}
			imageWidth={
				<>
					{wrapper ? wrapper({ children: <Image /> }) : <Image />}
					{descriptor}
				</>
			}
		/>
	)
}
